/**
 * Make sure to prefix any AJAX calls with this API base
 */
export var apiBase = "/dot-api/";
export var listRoutes = {
    show: "/profile/:username/bookmarks",
};
export var poisRoutes = {
    detail: ":slug(.*)?/a/:type/:id/:placeId",
    list: "(.*)?/a/:type-:subtype/:id$",
    lodgingAvailability: apiBase + "lodgings/availability/:lodgingId",
    nearby: apiBase + "pois/:id/nearby",
};
export var profileRoutes = {
    show: "/profile/:username",
};
export var blogRoutes = {
    previewPost: "/blog/preview/:wordpressId/",
    rss: "/blog/feed/atom",
    show: "/blog",
    showCategory: "/blog/category/:slug/:id?",
    showCategoryLatest: "/blog/latest",
    showPost: "/blog/:year/:month/:day/:slug/:id?",
};
export var bookmarkRoutes = {
    show: "/profile/:username/lists/:listId?",
    showList: "/profile/api/:username/lists",
};
export var searchRoutes = {
    searchApi: "/search/api",
    show: "/search",
    showJson: "/search.json",
    showLegacy: "/searchResult",
    showPreview: "/search-preview",
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/constants.ts
// module id = e9aK
// module chunks = 2 3